<template>
    <div>
        <vue-apex-charts type="line" ref="chart" height="465" @dataPointSelection="dataPointSelectionHandler" :options="chartOptions" :series="series"></vue-apex-charts>
    </div>
</template>
<script>

import VueApexCharts from 'vue-apexcharts'
import LocationTypeEnum from "../../LocationTypeEnum.js"

export default {
  components: {
    VueApexCharts
  },
  props: {
    mesuredElement: {
      type: Number,
      required: false,
      default : 0
    },
    isImported: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      chartOptions: {
        chart: {
          height: 350,
          type:"line"
        },
        fill: {
          type:'solid'
        },
        markers: {
          size: [6, 6, 6, 6]
        },
        tooltip: {
          shared: false,
          intersect: true,
          custom({ seriesIndex, dataPointIndex, w}) {
            let s  = '<div class="apexcharts-tooltip-title" style="font-family: Helvetica, Arial, sans-serif; font-size: 12px;">Infos</div>' + 
              '<div class="apexcharts-tooltip-series-group apexcharts-active" style="order: 1; display: flex;">' + 
                '<div class="apexcharts-tooltip-text" style="font-family: Helvetica, Arial, sans-serif; font-size: 12px;">' +
                    '<div class="apexcharts-tooltip-y-group">' + 
                      '<span class="apexcharts-tooltip-text-label">Grade : </span>' + 
                      '<span class="apexcharts-tooltip-text-value">' + w.config.series[seriesIndex].data[dataPointIndex].y + '</span>' +
                    '</div>' + 
                    '<div class="apexcharts-tooltip-z-group">' + 
                      '<span class="apexcharts-tooltip-text-z-label"></span>' + 
                      '<span class="apexcharts-tooltip-text-z-value"></span>' +
                    '</div>' + 
                  '</div>' + 
              '</div>';
            if (seriesIndex > 1) {
              s += '<div class="apexcharts-tooltip-series-group" style="order: 2; display: flex;">' + 
                  '<div class="apexcharts-tooltip-text" style="font-family: Helvetica, Arial, sans-serif; font-size: 12px;">' +
                      '<div class="apexcharts-tooltip-y-group">' + 
                        '<span class="apexcharts-tooltip-text-label">Diff % : </span>' + 
                        '<span class="apexcharts-tooltip-text-value">' + w.config.series[seriesIndex].data[dataPointIndex].pctFromAverage + '</span>' +
                      '</div>' + 
                      '<div class="apexcharts-tooltip-z-group">' + 
                        '<span class="apexcharts-tooltip-text-z-label"></span>' + 
                        '<span class="apexcharts-tooltip-text-z-value"></span>' +
                      '</div>' + 
                    '</div>' + 
                '</div>'
              s += '<div class="apexcharts-tooltip-series-group" style="order: 3; display: flex;">' + 
                  '<div class="apexcharts-tooltip-text" style="font-family: Helvetica, Arial, sans-serif; font-size: 12px;">' +
                      '<div class="apexcharts-tooltip-y-group">' + 
                        '<span class="apexcharts-tooltip-text-label">Method : </span>' + 
                        '<span class="apexcharts-tooltip-text-value">' + w.config.series[seriesIndex].data[dataPointIndex].methodName + '</span>' +
                      '</div>' + 
                      '<div class="apexcharts-tooltip-z-group">' + 
                        '<span class="apexcharts-tooltip-text-z-label"></span>' + 
                        '<span class="apexcharts-tooltip-text-z-value"></span>' +
                      '</div>' + 
                    '</div>' + 
                '</div>'
              s += '<div class="apexcharts-tooltip-series-group" style="order: 4; display: flex;">' + 
                  '<div class="apexcharts-tooltip-text" style="font-family: Helvetica, Arial, sans-serif; font-size: 12px;">' +
                      '<div class="apexcharts-tooltip-y-group">' + 
                        '<span class="apexcharts-tooltip-text-label">QCType : </span>' + 
                        '<span class="apexcharts-tooltip-text-value">' + w.config.series[seriesIndex].data[dataPointIndex].qcType + '</span>' +
                      '</div>' + 
                      '<div class="apexcharts-tooltip-z-group">' + 
                        '<span class="apexcharts-tooltip-text-z-label"></span>' + 
                        '<span class="apexcharts-tooltip-text-z-value"></span>' +
                      '</div>' + 
                    '</div>' + 
                '</div>'
            }

            return (s);
          }
        },
        legend: {
          show: true
        },
        colors: ["#000000", "#f2f2f2", "#00b33c", "#FF0000", "#FF8000", "#FF4500"],
        stroke: {
          width: [0, 0, 0, 0]
        },
        annotations: {},
        xaxis: {
          type: 'datetime'
        },
        yaxis: {
          type: 'numeric',
          title: {
            text: this.$systemUnits.getGradeUnitLabel()
          },
          labels: {
            formatter: (value) => {
              return value.toFixed(2)
            }
          }
        }
      },
      series: [],
      sampleElementsStats : [],
      includedLocationGrades : [],
      excludedLocationGrades : [],
      includedSampleGrades : [],
      excludedSampleGrades : [],
      locationCode: "",
      sampleNumber: "",
      muckDate: null
    };
  },
  watch: {
    mesuredElement() {
      if (this.sampleElementsStats !== []) {
        this.bindChartData(this.mesuredElement);
      }
    }
  },
  methods: {
    fillDatas(limsSampleResult, locationStats) {
      // reset data arrays
      this.includedLocationGrades = [];
      this.excludedLocationGrades = [];
      this.includedSampleGrades = [];
      this.excludedSampleGrades = [];
      this.autoExcludedSampleGrades = [];
      this.sampleElementsStats = [];
      this.locationCode = "";
      this.muckDate = null
      if (locationStats) {

        // define corresponding location code
        const typeDef = LocationTypeEnum.getSuffix(locationStats.locationType);
        this.locationCode = locationStats.locationCode + "-" + typeDef;

        // define corresponding muck extraction date
        if (limsSampleResult) {
          const sampleNumber = limsSampleResult.sampleMeasures[0].sampleNumber;
          if (sampleNumber) {
            const correspondingSample = locationStats.sampleInfos.find(m => m.code === sampleNumber)
            if (correspondingSample) {
              this.muckDate = correspondingSample.extractionDate;
            }
          }
        }
      }


      const elementList = [];
      
      // fill general stats (for average and +/- 20% area)
      limsSampleResult.sampleResultInfos.forEach(stat => {
        let locationElementStats = null;
        if (locationStats)
          locationElementStats =  locationStats.elementsGradeStats.find(r => r.element === stat.element);
        const data = {
          element :  stat.element,
          lower20Pct : stat.lower20Pct,
          upper20Pct : stat.upper20Pct,
          averageGrade: this.$systemUnits.convertGradeRounded(stat.grade, stat.element),
          locationGrade: locationElementStats === null || typeof locationElementStats === 'undefined' ? 0 : this.$systemUnits.convertGradeRounded(locationElementStats.grade, locationElementStats.element)
        };
        
        this.sampleElementsStats.push(data);
        elementList.push(stat.element);
      });

      if (locationStats)
      {
        const dates = locationStats.sampleInfos.map(m => m.extractionDate).filter((value, index, self) => self.indexOf(value) === index);

        // fill location sample results for each element
        elementList.forEach(element => {
          dates.forEach(date => {
            const dateLocationSampleInfo = locationStats.sampleInfos.filter(m => m.extractionDate === date);
            if (typeof dateLocationSampleInfo !== 'undefined') {
              dateLocationSampleInfo.forEach(dateLocationSampleInfo => {
                const elementResult = dateLocationSampleInfo.results.find(r => r.element === element)
                if (elementResult && elementResult.grade) {
                  if (elementResult.isExcluded) {
                    this.excludedLocationGrades.push({ x: date,  y: this.$systemUnits.convertGradeRounded(elementResult.grade, element), element})
                  } else {
                    this.includedLocationGrades.push({ x: date,  y: this.$systemUnits.convertGradeRounded(elementResult.grade, element), element})
                  }
                } 
              });
            }
          });
        })
      }
      
      // fill lims Sample measure for each element
      elementList.forEach(element => {
        const sampleMeasures = limsSampleResult.sampleMeasures.filter(m => m.element === element);
        if (typeof sampleMeasures !== 'undefined') {
          sampleMeasures.forEach(measure => {
            // if a muck correspnding muck was found, else certified date
            const sampleFullDate = this.muckDate ? new Date(this.muckDate) : new Date(measure.certifiedDate);
            // remove time from date time
            const sampleDate = new Date(sampleFullDate.getFullYear(), sampleFullDate.getMonth(), sampleFullDate.getDate());
            if (measure.isExcluded) {
              this.excludedSampleGrades.push({ 
                x: sampleDate,  
                y: this.$systemUnits.convertGradeRounded(measure.value, element), 
                sampleMeasureId : measure.sampleMeasureId, 
                pctFromAverage : measure.pctFromAverage, 
                element, 
                sampleNumber : measure.sampleNumber, 
                methodName :  measure.methodName, 
                qcType : this.$t("QCType." + measure.qcType) })
            } else if (measure.autoExcluded) {
              this.autoExcludedSampleGrades.push({ 
                x: sampleDate,  
                y: this.$systemUnits.convertGradeRounded(measure.value, element), 
                sampleMeasureId : measure.sampleMeasureId, 
                pctFromAverage : measure.pctFromAverage, 
                element, 
                sampleNumber : measure.sampleNumber,   
                methodName :  measure.methodName, 
                qcType : this.$t("QCType." + measure.qcType) })
            } else {
              this.includedSampleGrades.push({ 
                x: sampleDate,  
                y: this.$systemUnits.convertGradeRounded(measure.value, element), 
                sampleMeasureId : measure.sampleMeasureId, 
                pctFromAverage : measure.pctFromAverage, 
                element, 
                sampleNumber : measure.sampleNumber, 
                methodName :  measure.methodName, 
                qcType : this.$t("QCType." + measure.qcType) })
            }
          });
        }
      })
    },

    bindChartData(element) {
      // fill series
      const includedLocationSerie = {
        name:  this.$t('GradeControl.Sample.IncludedLocationSampleResults'),
        type: 'scatter',
        data: this.includedLocationGrades.filter(e => e.element === element)
      }

      const excludedLocationSerie = {
        name:  this.$t('GradeControl.Sample.ExcludedLocationSampleResults'),
        type: 'scatter',
        data: this.excludedLocationGrades.filter(e => e.element === element)
      }

      const includedSampleSerie = {
        name:  this.$t('GradeControl.Sample.IncludedSampleMeasure'),
        type: 'scatter',
        data: this.includedSampleGrades.filter(e => e.element === element)
      }

      const excludedSampleSerie = {
        name:  this.$t('GradeControl.Sample.ExcludedSampleMeasure'),
        type: 'scatter',
        data: this.excludedSampleGrades.filter(e => e.element === element)
      }

      const autoExcludedSampleSerie = {
        name:  this.$t('GradeControl.Sample.AutoExcludedSampleMeasure'),
        type: 'scatter',
        data: this.autoExcludedSampleGrades.filter(e => e.element === element)
      }
      
      this.series = [includedLocationSerie, excludedLocationSerie, includedSampleSerie, excludedSampleSerie, autoExcludedSampleSerie];

      const maxYValue = this.getMaxYValue() * 1.1;
      const maxDate = new Date(this.getMaxXValue());
      const maxXValue = maxDate.setDate(maxDate.getDate() + 2);

      const minDate = new Date(this.getMinXValue());
      const minXValue = minDate.setDate(minDate.getDate() - 2);

      const elementStats = this.sampleElementsStats.find(s => s.element === element);
      let annotations = { xaxis: [],  yaxis: [] };
      let xaxis = {
        type: 'datetime'
      };
      let yaxis = {
        type: 'numeric',
        title: {
          text: this.$systemUnits.getGradeUnitLabel()
        },
        labels: {
          formatter: (value) => {
            return value.toFixed(2)
          }
        }
      };
      // add +/20% area
      if (elementStats && elementStats.lower20Pct > 0) {
        annotations = {
          yaxis: [
            {
              y: elementStats.lower20Pct,
              y2: elementStats.upper20Pct,
              borderColor: '#1e7b1e',
              fillColor: '#99e699',
              label: {
                style: {
                  color: '#1e7b1e'
                },
                text: '+/- 20%'
              }
            },
            {
              y: elementStats.averageGrade,
              borderColor: '#1e7b1e'
            },
            {
              y: elementStats.locationGrade,
              borderColor: '#000000',
              
              label: {
                position: "left",
                offsetX: 65,
                offsetY: -5,
                text: this.locationCode
              }
            }
          ],
          xaxis: [
            {
              x: includedSampleSerie.data[0].x.getTime(),
              label: {
                style: {
                  color: '#145214'
                },
                orientation: "horizontal",
                text: includedSampleSerie.data[0].sampleNumber
              }
            }
          ]
        };
        yaxis = {
          type: 'numeric',
          title: {
            text: this.$systemUnits.getGradeUnitLabel()
          },
          max: maxYValue,
          labels: {
            formatter: (value) => {
              return value.toFixed(2)
            }
          }
        }

        xaxis = {
          type: 'datetime',
          max: maxXValue,
          min: minXValue
        };
      }

      if (element > 1) {
        yaxis.title.text = '%'
      }
        
      this.$refs.chart.updateOptions({ annotations, yaxis, xaxis });
      
    },
    getQCTypeName(qcType) {
      return this.$t("QCType." + qcType);
    },
    getMaxYValue() {
      let maxValue = 0;
      this.series.forEach(serie => {
        const maxSerieValue = Math.max.apply(null, serie.data.map(function(o) { return o.y; }));
        if (maxSerieValue > maxValue)
          maxValue = maxSerieValue;
      });

      return maxValue
    },

    getMaxXValue() {
      let maxValue = 0;
      this.series.forEach(serie => {
        const maxSerieValue = Math.max.apply(null, serie.data.map(function(o) { return o.x; }));
        if (maxSerieValue > maxValue)
          maxValue = maxSerieValue;
      });

      return maxValue
    },

    getMinXValue() {
      let minValue = 8640000000000000;
      this.series.forEach(serie => {
        const minSerieValue = Math.min.apply(null, serie.data.map(function(o) { return o.x; }));
        if (minSerieValue < minValue)
          minValue = minSerieValue;
      });

      return minValue
    },


    dataPointSelectionHandler(e, chartContext, config) {
      if (!this.isImported) {
        const samplePoint = config.w.config.series[config.seriesIndex].data[config.dataPointIndex];

        if (samplePoint !== 'undefined') {
          this.$emit("onUpdateSampleMeasure", samplePoint.sampleMeasureId);
        }
      }
    }
  }
};
</script>
